import { Modal } from 'components';
import { FC } from 'react';
import SectionStyled, { ContentStyled } from './styles';

interface PropsConfirmUpdateSchedule {
  visible: boolean;
  uploading?: boolean;
  onOK: () => void;
  onCancel: () => void;
  loading?: boolean;
}
const ConfirmUpdateSchedule: FC<PropsConfirmUpdateSchedule> = ({
  visible = false,
  onOK = () => null,
  onCancel = () => null,
  loading = false,
}) => {
  return (
    <SectionStyled>
      <Modal
        title="現場の予定期間を超過しています。よろしいですか？"
        visible={visible}
        width={640}
        loading={!!loading}
        okButton={{
          text: '確定と連絡',
          onClick: () => onOK(),
        }}
        cancelButton={{
          text: 'キャンセル',
          onClick: () => onCancel(),
        }}
      >
        <ContentStyled>確定すると遅延連絡として工事担当者に通知されます。</ContentStyled>
      </Modal>
    </SectionStyled>
  );
};

export default ConfirmUpdateSchedule;
